import { render } from "./MsgBox.vue?vue&type=template&id=765999d1&scoped=true"
import script from "./MsgBox.vue?vue&type=script&lang=js"
export * from "./MsgBox.vue?vue&type=script&lang=js"

import "./MsgBox.vue?vue&type=style&index=0&id=765999d1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765999d1"]])

export default __exports__